import React, { useEffect, useRef, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as AddTeamIcon } from "./Icons/Add Team Icon.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./addEvents.css";
import { useSelector, useDispatch } from "react-redux";
import { editEvent, viewEvent } from "../../Redux/Actions/eventActions";
import AddImage from "../../Global Functions/addImage";
import InnerHeading from "../../Global Functions/innerHeading";
import {
  viewCountryList,
  viewCityList,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import { viewBuilderList } from "../../Redux/Actions/builderActions";
import SelectInput from "../../Global Functions/selectInput";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { ToFirstCapital } from "../../Utils/helpers";
import MapsAddress from "../../Global Functions/mapsAddress";
import TextInput from "../../Global Functions/textInput";
import "./editEvents.css";

const EditEvents = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const startDateRef = useRef(null);
  const dispatch = useDispatch();

  const [selectedType, setSelectedType] = useState("");
  const [guestData, setGuestData] = useState({
    name: "",
    image: "",
    designation: "",
    organization: "",
  });

  const [trailerVideoData, setTrailerVideoData] = useState({
    url: "",
    type: "video",
    index: 0,
  });

  const [threeSixtyData, setThreeSixtyData] = useState({
    configuration: "",
    iframe_url: "",
    is_user_vr: true,
  });

  const [videoUploading, setVideoUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [eventPayload, setEventPayload] = useState({
    id: id,
    type: "",
    event_name: "",
    event_image: "",
    start_date: "",
    start_time: "",
    start_date_utc: "",
    end_date: "",
    end_time: "",
    end_date_utc: "",
    builder: "",
    lat: "",
    lng: "",
    about_event: "",
    address: "",
    cover_photo: "",
    guest_list: [
      {
        name: "",
        image: "",
        designation: "",
        organization: "",
      },
    ],
    country: "",
    state: "",
    city: "",
    youtube_link: "",
    video: "",
    image: [],
    trailer_videos: [],
    three_sixty: [],
  });

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { builders } = useSelector((state) => state.builders || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { event } = useSelector((state) => state.events || {});

  const isComingSoon = selectedType?.toLowerCase() === "coming_soon";
  const isTrailer = selectedType?.toLowerCase() === "trailer";

  const handleNavigationAddTeam = () => {
    navigate("/event");
  };

  const buildUTCDateTime = (date, time) => {
    if (!date || !time) return "";

    const [year, month, day] = date.split("-").map(Number);
    const [hours, minutes] = time.split(":").map(Number);

    const utcMillis = Date.UTC(year, month - 1, day, hours, minutes) - 330 * 60 * 1000;

    const utcDate = new Date(utcMillis);

    if (isNaN(utcDate.getTime())) return "";

    return utcDate.toISOString();
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;

    setEventPayload((prevData) => {
      const updatedPayload = {
        ...prevData,
        [name]: value,
      };

      if (name === "country") {
        updatedPayload.state = "";
        updatedPayload.city = "";
      }

      if (name === "state") {
        updatedPayload.city = "";
      }

      updatedPayload.start_date_utc = buildUTCDateTime(
        updatedPayload.start_date,
        updatedPayload.start_time
      );

      updatedPayload.end_date_utc = buildUTCDateTime(
        updatedPayload.end_date,
        updatedPayload.end_time
      );

      if (
        ["start_time", "end_time", "start_date", "end_date"].includes(name) &&
        updatedPayload.start_date &&
        updatedPayload.end_date &&
        updatedPayload.start_date === updatedPayload.end_date &&
        updatedPayload.start_time &&
        updatedPayload.end_time &&
        updatedPayload.start_time > updatedPayload.end_time
      ) {
        toast.error("Start time cannot be after end time on the same day.");
        return prevData;
      }

      return updatedPayload;
    });
  };

  const guestAdditionHandler = (event) => {
    event.preventDefault();
    if (guestData?.name?.trim()) {
      setEventPayload((prev) => ({
        ...prev,
        guest_list: [...(prev.guest_list || []), guestData],
      }));
      toast.success("Guest Added Successfully!!");
      setGuestData({
        name: "",
        image: "",
        designation: "",
        organization: "",
      });
    } else {
      toast.error("Problem adding Guest!!");
    }
  };

  const handleGuestAdd = (event) => {
    const { name, value } = event.target;
    setGuestData((prevData) => ({ ...prevData, [name]: value }));
  };

  const cleanPayload = (payload) => {
    const isEmpty = (value) =>
      value === "" || value === null || value === undefined;

    const isGuestEmpty = (guest) =>
      Object.values(guest).every((val) => isEmpty(val));

    const cleaned = {};

    for (const [key, value] of Object.entries(payload)) {
      if (key === "guest_list" && Array.isArray(value)) {
        const filteredGuests = value.filter((guest) => !isGuestEmpty(guest));
        if (filteredGuests.length > 0) {
          cleaned[key] = filteredGuests;
        }
      } else if (Array.isArray(value) && value.length > 0) {
        cleaned[key] = value;
      } else if (!isEmpty(value)) {
        cleaned[key] = value;
      }
    }

    return cleaned;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!eventPayload.type) {
      toast.error("You have to select Event type");
      return;
    }

    if (!eventPayload.event_name?.trim()) {
      toast.error(isTrailer ? "Trailer Name is required" : "Event Name is required");
      return;
    }

    if (!eventPayload.about_event?.trim()) {
      toast.error("About is required");
      return;
    }

    if (!eventPayload.start_date) {
      toast.error("Start Date is required");
      return;
    }

    if (!eventPayload.start_time) {
      toast.error("Start Time is required");
      return;
    }

    if (!eventPayload.end_date) {
      toast.error("End Date is required");
      return;
    }

    if (!eventPayload.end_time) {
      toast.error("End Time is required");
      return;
    }

    if (!eventPayload.cover_photo?.trim()) {
      toast.error(
        isTrailer ? "Cover Photo is required for Trailer" : "Cover Photo is required"
      );
      return;
    }

    if (isTrailer && (!eventPayload.trailer_videos || eventPayload.trailer_videos.length === 0)) {
      toast.error("At least one Trailer Video is required");
      return;
    }

    if (isComingSoon && !eventPayload.builder?.trim()) {
      toast.error("Builder is required for Coming Soon events");
      return;
    }

    const finalPayload = {
      ...eventPayload,
      start_date_utc: buildUTCDateTime(eventPayload.start_date, eventPayload.start_time),
      end_date_utc: buildUTCDateTime(eventPayload.end_date, eventPayload.end_time),
      country:
        typeof eventPayload.country === "object"
          ? eventPayload.country?._id || ""
          : eventPayload.country,
      state:
        typeof eventPayload.state === "object"
          ? eventPayload.state?._id || ""
          : eventPayload.state,
      city:
        typeof eventPayload.city === "object"
          ? eventPayload.city?._id || ""
          : eventPayload.city,
    };

    const cleanedPayload = cleanPayload(finalPayload);
    console.log("FINAL PAYLOAD SENT:", cleanedPayload.start_date_utc);

    try {
      const response = await dispatch(editEvent(cleanedPayload));
      if (response?.statusCode === 200) {
        navigate("/event");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    dispatch(viewCountryList({ page: 1, limit: 250 }));
  }, [dispatch]);

  useEffect(() => {
    const countryId =
      typeof eventPayload.country === "object"
        ? eventPayload.country?._id
        : eventPayload.country;

    if (countryId) {
      dispatch(viewStateListPagination({ country: countryId }));
    }
  }, [dispatch, eventPayload.country]);

  useEffect(() => {
    const countryId =
      typeof eventPayload.country === "object"
        ? eventPayload.country?._id
        : eventPayload.country;

    const stateId =
      typeof eventPayload.state === "object"
        ? eventPayload.state?._id
        : eventPayload.state;

    if (countryId && stateId) {
      dispatch(
        viewCityList({
          page: 1,
          limit: 200,
          state: stateId,
          country: countryId,
        })
      );
    }
  }, [dispatch, eventPayload.country, eventPayload.state]);

  useEffect(() => {
    const builderPayload = {
      page: 1,
      limit: 1000,
      is_deleted: false,
    };
    dispatch(getEnums());
    dispatch(viewBuilderList(builderPayload));
  }, [dispatch]);

  const addHoursToTime = (timeStr, hoursToAdd) => {
    if (!timeStr) return "00:00";
    let [h, m] = timeStr.split(":").map(Number);
    h += hoursToAdd;
    if (h >= 24) h = 23;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  useEffect(() => {
    dispatch(viewEvent(id));
  }, [dispatch, id]);

  const defaultPayload = {
    id: id,
    type: "",
    event_name: "",
    event_image: "",
    start_date: "",
    start_time: "",
    start_date_utc: "",
    end_date: "",
    end_time: "",
    end_date_utc: "",
    builder: "",
    lat: "",
    lng: "",
    about_event: "",
    address: "",
    cover_photo: "",
    guest_list: [],
    country: "",
    state: "",
    city: "",
    youtube_link: "",
    video: "",
    image: [],
    trailer_videos: [],
    three_sixty: [],
  };

  useEffect(() => {
    if (event?.data) {
      console.log("start_date:", event.data.start_date);
      console.log("start_time:", event.data.start_time);
      console.log("built UTC:", buildUTCDateTime(event.data.start_date, event.data.start_time));
      const countryValue =
        typeof event.data.country === "object"
          ? event.data.country?._id || ""
          : event.data.country || "";

      const stateValue =
        typeof event.data.state === "object"
          ? event.data.state?._id || ""
          : event.data.state || "";

      const cityValue =
        typeof event.data.city === "object"
          ? event.data.city?._id || ""
          : event.data.city || "";

      setEventPayload({
        ...defaultPayload,
        ...event.data,
        country: countryValue,
        state: stateValue,
        city: cityValue,
        address: event.data.address || "",
        lat: event.data.lat || "",
        lng: event.data.lng || "",
        start_date: event.data.start_date || "",
        end_date: event.data.end_date || "",
        start_time: event.data.start_time || "",
        end_time: event.data.end_time || "",
        start_date_utc:
          buildUTCDateTime(event.data.start_date, event.data.start_time),
        end_date_utc:
          buildUTCDateTime(event.data.end_date, event.data.end_time),
        video: event.data.trailer_videos?.[0] || event.data.video || "",
        trailer_videos: event.data.trailer_videos || [],
        three_sixty: event.data.three_sixty || [],
        youtube_link: event.data.youtube_link || "",
      });

      setSelectedType(event.data.type || "");
    }
  }, [event?.data]);

  const handleAddressChange = ({ address, lat, lng, country, state, city }) => {
    setEventPayload((prev) => ({
      ...prev,
      address: address || "",
      lat: lat || "",
      lng: lng || "",
      country:
        country ||
        prev.country,
      state:
        state ||
        prev.state,
      city:
        city ||
        prev.city,
    }));
  };

  const validImageTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];

  const validVideoTypes = [
    "video/mp4",
    "video/avi",
    "video/mov",
    "video/wmv",
    "video/mkv",
    "video/webm",
  ];

  const handleMediaUpload = async (event, targetKey, mediaType) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) {
      toast.error("No File Uploaded");
      return;
    }

    const validTypes = mediaType === "image" ? validImageTypes : validVideoTypes;

    if (!validTypes.includes(uploadedFile.type)) {
      toast.error(`Only ${mediaType} files are allowed!`);
      event.target.value = "";
      return;
    }

    if (targetKey === "video") {
      setVideoUploading(true);
      setUploadProgress(0);

      const progressInterval = setInterval(() => {
        setUploadProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 300);

      const responseUrl = await AddImage(uploadedFile);
      clearInterval(progressInterval);
      setUploadProgress(100);

      if (responseUrl) {
        setEventPayload((prevData) => ({ ...prevData, [targetKey]: responseUrl }));
        event.target.value = "";
      }

      setVideoUploading(false);
      setTimeout(() => setUploadProgress(0), 1000);
    } else if (targetKey === "trailer_video") {
      setVideoUploading(true);
      setUploadProgress(0);

      const progressInterval = setInterval(() => {
        setUploadProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 300);

      const responseUrl = await AddImage(uploadedFile);
      clearInterval(progressInterval);
      setUploadProgress(100);

      if (responseUrl) {
        setTrailerVideoData((prevData) => ({
          ...prevData,
          url: responseUrl,
        }));
        event.target.value = "";
        toast.success("Video uploaded successfully!");
      }

      setVideoUploading(false);
      setTimeout(() => setUploadProgress(0), 1000);
    } else {
      const responseUrl = await AddImage(uploadedFile);
      if (responseUrl) {
        if (targetKey === "guest_image") {
          setGuestData((prevData) => ({ ...prevData, image: responseUrl }));
        } else if (targetKey === "image") {
          setEventPayload((prevData) => ({
            ...prevData,
            image: [...(prevData.image || []), responseUrl],
          }));
        } else {
          setEventPayload((prevData) => ({ ...prevData, [targetKey]: responseUrl }));
        }
        event.target.value = "";
      }
    }
  };

  const handleRemoveVideo = () => {
    setEventPayload((prevData) => ({ ...prevData, video: "" }));
  };

  const addTrailerVideoHandler = (event) => {
    event.preventDefault();

    if (trailerVideoData.url.trim()) {
      setEventPayload((prev) => ({
        ...prev,
        trailer_videos: [
          ...(prev.trailer_videos || []),
          {
            url: trailerVideoData.url,
            type: "video",
            index: prev.trailer_videos?.length || 0,
          },
        ],
      }));
      toast.success("Trailer Video Added Successfully!!");
      setTrailerVideoData({
        url: "",
        type: "video",
        index: 0,
      });
    } else {
      toast.error("Please provide a video URL!!");
    }
  };

  const removeTrailerVideo = (index) => {
    setEventPayload((prevData) => ({
      ...prevData,
      trailer_videos: prevData.trailer_videos.filter((_, i) => i !== index),
    }));
    toast.success("Trailer Video Removed!");
  };

  const addThreeSixtyHandler = (event) => {
    event.preventDefault();

    if (threeSixtyData.configuration.trim() && threeSixtyData.iframe_url.trim()) {
      setEventPayload((prev) => ({
        ...prev,
        three_sixty: [...(prev.three_sixty || []), threeSixtyData],
      }));
      toast.success("360 Content Added Successfully!!");
      setThreeSixtyData({
        configuration: "",
        iframe_url: "",
        is_user_vr: true,
      });
    } else {
      toast.error("Please fill in all required fields!!");
    }
  };

  const removeThreeSixty = (index) => {
    setEventPayload((prevData) => ({
      ...prevData,
      three_sixty: prevData.three_sixty.filter((_, i) => i !== index),
    }));
    toast.success("360 Content Removed!");
  };

  const isSameDate = eventPayload.start_date === eventPayload.end_date;
  const minEndTime = isSameDate
    ? addHoursToTime(eventPayload.start_time, 3)
    : "00:00";

  const eventTypesEnums = enumsData?.data?.eventType
    ? Object.values(enumsData.data.eventType).map((item) => item)
    : [];

  const typeSelectionHandler = (event) => {
    const updatedType = event.target.value;
    if (!updatedType) {
      return toast.error("Please select a type - Event or Coming Soon");
    }
    setSelectedType(updatedType);
    setEventPayload((prevData) => ({
      ...prevData,
      type: updatedType,
    }));
  };

  return (
    <MainLayout>
      <div className="event-container">
        <InnerHeading
          Icon={AddTeamIcon}
          heading="Edit Event"
          buttonLabel="View Event List"
          onClick={handleNavigationAddTeam}
        />

        <form className="event-form">
          <div className="form-section">
            <h2 className="section-title">Event Type</h2>
            <div className="form-grid">
              <div className="form-field full-width">
                <SelectInput
                  onChange={typeSelectionHandler}
                  placeholder="Select an Option"
                  label="Select Type"
                  value={eventPayload.type}
                  options={
                    Array.isArray(eventTypesEnums)
                      ? eventTypesEnums.map((enums) => ({
                        label: ToFirstCapital(enums),
                        value: enums,
                      }))
                      : []
                  }
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2 className="section-title">Basic Information</h2>
            <div className="form-grid">
              <div className="form-field">
                <label className="form-label">
                  {isTrailer ? "Trailer Name" : "Event Name"}
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="form-input"
                  type="text"
                  name="event_name"
                  value={eventPayload.event_name}
                  onChange={handleAddChange}
                  placeholder={isTrailer ? "Enter trailer name" : "Enter event name"}
                />
              </div>

              {isComingSoon && (
                <div className="form-field">
                  <SelectInput
                    onChange={handleAddChange}
                    label="Select Builder"
                    name="builder"
                    value={eventPayload.builder}
                    placeholder="Select an Option"
                    options={
                      Array.isArray(builders?.data)
                        ? builders.data.map((builder) => ({
                          label: builder.brand_name,
                          value: builder._id,
                        }))
                        : []
                    }
                  />
                </div>
              )}

              <div className="form-field full-width">
                <label className="form-label">
                  About<span className="required">*</span>
                </label>
                <textarea
                  required
                  className="form-textarea"
                  name="about_event"
                  value={eventPayload.about_event}
                  onChange={handleAddChange}
                  placeholder="Describe your event"
                  rows="4"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2 className="section-title">Date & Time</h2>
            <div className="form-grid grid-4">
              <div className="form-field">
                <label className="form-label">
                  Start Date<span className="required">*</span>
                </label>
                <input
                  ref={startDateRef}
                  className="form-input"
                  type="date"
                  required
                  name="start_date"
                  value={eventPayload.start_date}
                  onChange={handleAddChange}
                />
              </div>

              <div className="form-field">
                <label className="form-label">
                  Start Time<span className="required">*</span>
                </label>
                <input
                  required
                  className="form-input"
                  type="time"
                  name="start_time"
                  value={eventPayload.start_time}
                  onChange={handleAddChange}
                />
              </div>

              <div className="form-field">
                <label className="form-label">
                  End Date<span className="required">*</span>
                </label>
                <input
                  required
                  className="form-input"
                  min={eventPayload.start_date}
                  type="date"
                  name="end_date"
                  value={eventPayload.end_date}
                  onChange={handleAddChange}
                />
              </div>

              <div className="form-field">
                <label className="form-label">
                  End Time<span className="required">*</span>
                </label>
                <input
                  required
                  className="form-input"
                  min={minEndTime}
                  type="time"
                  name="end_time"
                  value={eventPayload.end_time}
                  onChange={handleAddChange}
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2 className="section-title">Media</h2>

            {!isTrailer ? (
              <>
                <div className="form-grid grid-3">
                  <div className="form-field">
                    <label className="form-label">
                      Cover Photo<span className="required">*</span>
                    </label>
                    <input
                      required
                      id="cover_photo"
                      className="form-input"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      name="cover_photo"
                      onChange={(e) => handleMediaUpload(e, "cover_photo", "image")}
                      style={{ display: "none" }}
                    />
                    <label className="upload-label" htmlFor="cover_photo">
                      Upload Cover Photo
                    </label>
                    <ImageShowerModalGlobal
                      state={eventPayload}
                      setState={setEventPayload}
                      keyField="cover_photo"
                      file={eventPayload.cover_photo}
                    />
                  </div>

                  <div className="form-field">
                    <label className="form-label">Event Image</label>
                    <input
                      className="form-input"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      name="event_image"
                      id="event_image"
                      style={{ display: "none" }}
                      onChange={(e) => handleMediaUpload(e, "event_image", "image")}
                    />
                    <label className="upload-label" htmlFor="event_image">
                      Upload Event Image
                    </label>
                    <ImageShowerModalGlobal
                      state={eventPayload}
                      setState={setEventPayload}
                      keyField="event_image"
                      file={eventPayload.event_image}
                    />
                  </div>

                  <div className="form-field">
                    <label className="form-label">Upload Video</label>
                    <input
                      className="form-input"
                      type="file"
                      name="video"
                      id="video"
                      accept="video/mp4, video/avi, video/mov, video/wmv, video/mkv, video/webm"
                      onChange={(e) => handleMediaUpload(e, "video", "video")}
                      style={{ display: "none" }}
                    />
                    <label className="upload-label" htmlFor="video">
                      Upload Video
                    </label>

                    {videoUploading && (
                      <div className="upload-progress">
                        <div className="progress-text">
                          Uploading video... {uploadProgress}%
                        </div>
                        <div className="progress-bar">
                          <div
                            className="progress-fill"
                            style={{
                              width: `${uploadProgress}%`,
                              backgroundColor:
                                uploadProgress === 100 ? "#10b981" : "#3b82f6",
                            }}
                          >
                            {uploadProgress > 0 && `${uploadProgress}%`}
                          </div>
                        </div>
                      </div>
                    )}

                    {eventPayload.video && (
                      <div className="video-preview">
                        <video controls>
                          <source src={eventPayload.video} type="video/mp4" />
                        </video>
                        <button
                          type="button"
                          onClick={handleRemoveVideo}
                          className="remove-video-btn"
                          aria-label="Remove video"
                        >
                          ×
                        </button>
                      </div>
                    )}
                  </div>
                </div>


                <div className="form-grid">
                  <div className="form-field full-width">
                    <label className="form-label">
                      Youtube Link
                    </label>
                    <input
                      className="form-input"
                      type="text"
                      name="youtube_link"
                      value={eventPayload.youtube_link}
                      onChange={handleAddChange}
                      placeholder="https://youtube.com/..."
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="form-section">
                  <h3 className="section-title" style={{ marginBottom: "20px" }}>
                    Trailer Videos
                  </h3>
                  <div className="guest-container">
                    <div className="guest-form-card">
                      <h4 className="card-subtitle">Add Trailer Video</h4>

                      <div className="form-field full-width">
                        <label className="form-label">Upload Video</label>
                        <input
                          className="form-input"
                          type="file"
                          name="trailer_video"
                          id="trailer_video"
                          accept="video/mp4, video/avi, video/mov, video/wmv, video/mkv, video/webm"
                          onChange={(e) =>
                            handleMediaUpload(e, "trailer_video", "video")
                          }
                          style={{ display: "none" }}
                        />
                        <label className="upload-label" htmlFor="trailer_video">
                          Upload Trailer Video
                        </label>
                      </div>

                      {videoUploading && (
                        <div className="upload-progress">
                          <div className="progress-text">
                            Uploading video... {uploadProgress}%
                          </div>
                          <div className="progress-bar">
                            <div
                              className="progress-fill"
                              style={{
                                width: `${uploadProgress}%`,
                                backgroundColor:
                                  uploadProgress === 100 ? "#10b981" : "#3b82f6",
                              }}
                            >
                              {uploadProgress > 0 && `${uploadProgress}%`}
                            </div>
                          </div>
                        </div>
                      )}

                      {trailerVideoData.url && (
                        <div className="video-preview">
                          <video controls>
                            <source src={trailerVideoData.url} type="video/mp4" />
                          </video>
                          <button
                            type="button"
                            onClick={() =>
                              setTrailerVideoData({ ...trailerVideoData, url: "" })
                            }
                            className="remove-video-btn"
                            aria-label="Remove video"
                          >
                            ×
                          </button>
                        </div>
                      )}

                      <button
                        className="btn-primary full-width"
                        disabled={!trailerVideoData.url.trim()}
                        onClick={addTrailerVideoHandler}
                        type="button"
                      >
                        Add Trailer Video
                      </button>
                    </div>

                    <div className="guest-list-card">
                      <h4 className="card-subtitle">Trailer Videos List</h4>
                      {eventPayload?.trailer_videos &&
                        eventPayload.trailer_videos.length > 0 ? (
                        <div className="guest-list">
                          {eventPayload.trailer_videos.map((item, index) => (
                            <div key={index} style={{ marginBottom: "16px" }}>
                              <div className="guest-item">
                                <div className="guest-info" style={{ flex: 1 }}>
                                  <h4
                                    className="guest-name"
                                    style={{
                                      whiteSpace: "normal",
                                      overflow: "visible",
                                      textOverflow: "clip",
                                    }}
                                  >
                                    {item.url.substring(item.url.lastIndexOf("/") + 1)}
                                  </h4>
                                  <p className="guest-role">Type: {item.type}</p>
                                </div>
                                <button
                                  type="button"
                                  className="btn-remove"
                                  onClick={() => removeTrailerVideo(index)}
                                >
                                  Remove
                                </button>
                              </div>
                              <div
                                className="video-preview"
                                style={{ marginTop: "12px", width: "100%" }}
                              >
                                <video controls style={{ width: "100%" }}>
                                  <source src={item.url} type="video/mp4" />
                                </video>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="empty-state">
                          <p>No trailer videos added yet</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <h3 className="section-title" style={{ marginBottom: "20px" }}>
                    360 VR Content
                  </h3>
                  <div className="guest-container">
                    <div className="guest-form-card">
                      <h4 className="card-subtitle">Add 360 Content</h4>

                      <div className="form-field full-width">
                        <label className="form-label">Configuration</label>
                        <input
                          className="form-input"
                          type="text"
                          name="configuration"
                          value={threeSixtyData.configuration}
                          onChange={(e) =>
                            setThreeSixtyData({
                              ...threeSixtyData,
                              configuration: e.target.value,
                            })
                          }
                          placeholder="Enter configuration"
                        />
                      </div>

                      <div className="form-field full-width">
                        <label className="form-label">iFrame URL</label>
                        <input
                          className="form-input"
                          type="text"
                          name="iframe_url"
                          value={threeSixtyData.iframe_url}
                          onChange={(e) =>
                            setThreeSixtyData({
                              ...threeSixtyData,
                              iframe_url: e.target.value,
                            })
                          }
                          placeholder="Enter iFrame URL"
                        />
                      </div>

                      <div className="form-field full-width">
                        <label className="form-label">
                          <input
                            type="checkbox"
                            checked={threeSixtyData.is_user_vr}
                            onChange={(e) =>
                              setThreeSixtyData({
                                ...threeSixtyData,
                                is_user_vr: e.target.checked,
                              })
                            }
                            style={{ marginRight: "8px" }}
                          />
                          Is User VR
                        </label>
                      </div>

                      <button
                        className="btn-primary full-width"
                        disabled={
                          !threeSixtyData.configuration.trim() ||
                          !threeSixtyData.iframe_url.trim()
                        }
                        onClick={addThreeSixtyHandler}
                        type="button"
                      >
                        Add 360 Content
                      </button>
                    </div>

                    <div className="guest-list-card">
                      <h4 className="card-subtitle">360 Content List</h4>
                      {eventPayload?.three_sixty &&
                        eventPayload.three_sixty.length > 0 ? (
                        <div className="guest-list">
                          {eventPayload.three_sixty.map((item, index) => (
                            <div className="guest-item" key={index}>
                              <div className="guest-info" style={{ flex: 1 }}>
                                <h4 className="guest-name">{item.configuration}</h4>
                                <p className="guest-role">URL: {item.iframe_url}</p>
                                <p className="guest-role">
                                  VR: {item.is_user_vr ? "Yes" : "No"}
                                </p>
                              </div>
                              <button
                                type="button"
                                className="btn-remove"
                                onClick={() => removeThreeSixty(index)}
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="empty-state">
                          <p>No 360 content added yet</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="form-section">
            <h2 className="section-title">Location</h2>
            <div className="form-grid">
              <div className="form-field full-width">
                <MapsAddress
                  value={{
                    address: eventPayload.address,
                    lat: eventPayload.lat,
                    lng: eventPayload.lng,
                  }}
                  onChange={handleAddressChange}
                  showAsterisk={false}
                />
              </div>

              <div className="form-field">
                <SelectInput
                  name="country"
                  label="Country"
                  value={eventPayload.country || ""}
                  onChange={handleAddChange}
                  options={
                    Array.isArray(countryList?.data)
                      ? countryList.data.map((country) => ({
                        label: country.country_name,
                        value: country._id,
                      }))
                      : []
                  }
                />
              </div>

              <div className="form-field">
                <SelectInput
                  name="state"
                  label="State"
                  value={eventPayload.state || ""}
                  onChange={handleAddChange}
                  options={
                    Array.isArray(states?.data)
                      ? states.data.map((state) => ({
                        label: state.state_name,
                        value: state._id,
                      }))
                      : []
                  }
                />
              </div>

              <div className="form-field">
                <SelectInput
                  name="city"
                  label="City"
                  value={eventPayload.city || ""}
                  onChange={handleAddChange}
                  options={
                    Array.isArray(cities?.data)
                      ? cities.data.map((city) => ({
                        label: city.city_name,
                        value: city._id,
                      }))
                      : []
                  }
                />
              </div>
            </div>
          </div>

          {!isTrailer && (
            <div className="form-section">
              <h2 className="section-title">Guest Details</h2>
              <div className="guest-container">
                <div className="guest-form-card">
                  <h3 className="card-subtitle">Add Guest</h3>

                  <div className="form-field">
                    <label className="form-label">Guest Image</label>
                    <input
                      className="form-input"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                      onChange={(e) => handleMediaUpload(e, "guest_image", "image")}
                      id="guest_image1"
                      style={{ display: "none" }}
                    />
                    <label className="upload-label" htmlFor="guest_image1">
                      Upload Guest Image
                    </label>
                    <ImageShowerModalGlobal
                      state={guestData}
                      setState={setGuestData}
                      keyField="image"
                      file={guestData.image}
                    />
                  </div>

                  <div className="form-field">
                    <TextInput
                      label="Name"
                      type="text"
                      name="name"
                      value={guestData.name}
                      onChange={handleGuestAdd}
                    />
                  </div>

                  <div className="form-grid grid-2">
                    <div className="form-field">
                      <TextInput
                        type="text"
                        label="Designation"
                        name="designation"
                        onChange={handleGuestAdd}
                        value={guestData.designation}
                      />
                    </div>

                    <div className="form-field">
                      <TextInput
                        onChange={handleGuestAdd}
                        value={guestData.organization}
                        type="text"
                        name="organization"
                        label="Organization"
                      />
                    </div>
                  </div>

                  <button
                    className="btn-primary full-width"
                    disabled={!guestData.name.trim()}
                    onClick={guestAdditionHandler}
                    type="button"
                  >
                    Add Guest
                  </button>
                </div>

                <div className="guest-list-card">
                  <h3 className="card-subtitle">Guest List</h3>
                  {eventPayload?.guest_list && eventPayload.guest_list.length > 0 ? (
                    <div className="guest-list">
                      {eventPayload.guest_list
                        .filter((item) => item.name && item.image)
                        .map((item, index) => (
                          <div className="guest-item" key={index}>
                            <div className="guest-image">
                              {item.image ? (
                                <img src={item.image} alt={item.name} />
                              ) : (
                                <div className="guest-avatar">
                                  {item.name.charAt(0).toUpperCase()}
                                </div>
                              )}
                            </div>
                            <div className="guest-info">
                              <h4 className="guest-name">{item.name}</h4>
                              <p className="guest-role">
                                {item.designation}
                                {item.designation && item.organization && " at "}
                                {item.organization}
                              </p>
                            </div>
                            <button
                              type="button"
                              className="btn-remove"
                              onClick={() =>
                                setEventPayload((prevData) => ({
                                  ...prevData,
                                  guest_list: prevData.guest_list.filter(
                                    (_, i) => i !== index
                                  ),
                                }))
                              }
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div className="empty-state">
                      <p>No guests added yet</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="form-actions">
            <Link to="/event">
              <button type="button" className="btn-secondary">
                Cancel
              </button>
            </Link>
            <button onClick={handleSubmit} className="btn-primary" type="button">
              {isTrailer
                ? "Save Trailer"
                : isComingSoon
                  ? "Save Coming Soon"
                  : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditEvents;